import 'slick-carousel'
import GET_ARTICLES from '../plugins/getArticles'
import GET_CATEGORIES from '../plugins/getCategories';
import SCROLL_NAV from '../plugins/scrollNav';
import FULLCALENDAR from '../plugins/fullcalendar';

export default function HOME() {

  $(() => {
  
    // トップページカスタム
    $.topInit()

    // カテゴリデータ取得
    window.load['block-wholesale'].done(()=> {
      GET_CATEGORIES('#main').done(()=>{
        SCROLL_NAV('.p-block-wholesale__catlist') // スワイプ対応ナビ
        SCROLL_NAV('.p-block-shop__catlist') // スワイプ対応ナビ
      })
    })

    window.load['block-schedule'].done(()=>{
      // fullcalendar挿入
      FULLCALENDAR(document.querySelectorAll('[data-plugin="calendar"]'),{
        googleCalendarApiKey: 'AIzaSyAp7Q8UGPJkuCJnRnq4M9PZgilB1XTkVQM',
        contentHeight: 467,
        eventSources: [
          {
            googleCalendarId: 'info@hagukumuhito.net',
            className: 'info',
            backgroundColor: '#865A5A',
            borderColor: '#865A5A'
          },
          {
            googleCalendarId: 'hagukumuhito.net_or9c1q1ol4aflutlslkocgsqm0@group.calendar.google.com',
            className: 'hagukumuhito01',
            backgroundColor: '#0F4B38',
            borderColor: '#0F4B38'
          },
          {
            googleCalendarId: 'hagukumuhito.net_668tan36qbgd1mrg598qs1bc50@group.calendar.google.com',
            className: 'hagukumuhito02',
            backgroundColor: '#23164E',
            borderColor: '#23164E'
          },
          {
            googleCalendarId: 'japanese__ja@holiday.calendar.google.com',
            className: 'holiday'
          }
        ]
      })
    })

  })

  $(window).on('load', () => {

    // 記事データ取得
    GET_ARTICLES('#main').done(() => $('[data-slick="true"]').slick({
      autoplay: false,
      fade: false,
      speed: 200,
      pauseOnHover: false,
      pauseOnFocus: false,
      arrows: true,
      infinite: false,
      variableWidth: true,
      swipeToSlide:true,
      slidesToShow: 4,
      responsive: [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        }
      }, {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          infinite: true,
          centerMode: true
        }
      }]
    }))

  })
  
}